module.exports = __webpack_public_path__ + "static/media/3.d8f07bd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_41/images/九宫格选中态/3.png
// module id = 951
// module chunks = 0